import ReactApexChart from "react-apexcharts";

function getRandomInt() {
  return Math.floor(Math.random() * 101);
}

const CSOsFinanceRadar = ({ comparisonData }) => {
  const rawComparisonData = {
    ...comparisonData,
  };
  delete rawComparisonData.year;

  const mappedComparisonData = Object.keys(rawComparisonData).reduce(
    (acc, axisKey) => {
      acc[axisKey] = rawComparisonData[axisKey].reduce((accChild, currCso) => {
        accChild[currCso.cso_name] = currCso.data[currCso.data.length - 1];
        // accChild[currCso.cso_name] = getRandomInt();
        return accChild;
      }, {});
      return acc;
    },
    {}
  );

  const xxaxis = Object.keys(rawComparisonData);
  const csos = rawComparisonData[xxaxis[0]].map((cso) => cso.cso_name);
  const series = csos.map((cso) => {
    return {
      name: cso,
      data: xxaxis.map((axis) => {
        return mappedComparisonData[axis][cso];
      }),
    };
  });

  const options = {
    series: series,
    xxaxis: {
      categories: xxaxis,
    },
    labels: xxaxis,
    chart: {
      height: 350,
      type: "radar",
      toolbar: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (num) {
          // round two 2 decimal
          return num.toFixed(2);
        },
      },
    },
  };

  return (
    <div>
      {" "}
      <ReactApexChart type="radar" series={series} options={options} />
    </div>
  );
};

export default CSOsFinanceRadar;
